module.exports = __webpack_public_path__ + "media/images/logo-desk-nl-white-8fb03f1ddee4f793d1b8d1c988dd6a75.svg";